import {Space} from "antd";
import {LiveEventCheckoutFormGroups} from "../../accordion/data";
import {OfferingFormAccordionItem} from "../../accordion/accordion-item";
import {LiveEventCheckoutFormFieldsProps} from "./types";

export function LiveEventCheckoutFormFields({
  isBookingQuestionsError,
}: LiveEventCheckoutFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {LiveEventCheckoutFormGroups.map((fg, index) => {
        if (fg.title === "Checkout form") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isBookingQuestionsError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
